import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./recipient-select.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./recipient-select.component.scss?ngResource";
import { ChangeDetectorRef, Component, forwardRef, Input } from "@angular/core";
import { take, map } from "rxjs";
import { RecipientSelectConstants } from "./recipient-select.constants";
import { FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validators } from "@angular/forms";
import { RecipientService } from "../shared/shared-services/recipient.service";
import { AppControllerService } from "../../../../app-controller.service";
import { DefaultRequiredFields } from "../../../models/application/generic/recipient.model";
import { SharedConstants } from "../../../constants/shared.constants";
import { CRUDOperation } from "../../../models/crud-operation-enum.model";
import RecipientUtils from "../../../utils/recipient-utils";
import { phoneNumberValidator } from "../../../classes/phone-number-validator";
import { UserInformationService } from "../../../services/user/user-information.service";
import { LookupConstants } from "../../../constants/lookup.constants";
import { UcFirstPipe } from "ngx-pipes";
import { AlertType } from "../../../models/alert";
import { ApplicationCreateService } from "../../../../create-application/shared/application-create.service";
let RecipientSelectComponent = class RecipientSelectComponent {
    recipientService;
    appCreateService;
    appControllerService;
    userInformationService;
    upperFirst;
    changeDetectorRef;
    overrideGroup = false;
    stepMetaRecipientGroups = [];
    isGroupsComingFromMetadata = true;
    showGroupsDropdown = true;
    disableEditing = false;
    showAllFormFields = true;
    disableFilter = true;
    jobId;
    formName;
    configurableLabel;
    showSACAPOptions = false;
    showRecipientGroupsDropdown = true;
    groupsOptions = [];
    hideFilter = false;
    hideAddButton = false;
    recipientForm;
    Validator = Validators;
    recipientFormLabelHeading = "Recipient details";
    provinceOptions = LookupConstants.PROVINCE;
    countryOptions = LookupConstants.COUNTRIES;
    maritalStatusOptions = LookupConstants.MARITAL_STATUS_LOOKUPS_RECIPIENT_COMPONENTS;
    employmentStatusOptions = LookupConstants.EMPLOYMENT_STATUS_LOOKUPS_RECIPIENT_COMPONENTS;
    selectOptionText = SharedConstants.NO_OPTION_SELECTED;
    sameAsResidentialChecked = false;
    genderOptions = [];
    disabilityOptions = [];
    // moduleId;
    groupsFromMetadata;
    onChangeSubscription;
    defaultRequiredFields = DefaultRequiredFields;
    recipientGroupSettings = [];
    verifiedSACAPNumber = null;
    idNumberConfiguredVisible = true;
    passportNumberConfiguredVisible = false;
    idNumberConfiguredRequired = false;
    passportNumberConfiguredRequired = false;
    // control visibility
    showNameField = true;
    showSurnameField = true;
    showHomeTelephoneField = true;
    showWorkTelephoneField = true;
    showCellphoneField = true;
    showEmailField = true;
    showPassportNumberField = false;
    showIdPassportSelectionField = false;
    showGenderField = false;
    showDisabilityField = false;
    showOrganisationField = true;
    showDesignationField = true;
    showProfessionalBodyField = true;
    showProfessionalBodyRegNumField = true;
    showStreetAddressField = true;
    showWardAreaNameField = false;
    showStreetSuburbField = true;
    showStreetCityField = true;
    showStreetProvinceField = true;
    showStreetCountryField = true;
    showStreetCodeField = true;
    showPostalAddressField = true;
    showPostalSuburbField = true;
    showPostalCityField = true;
    showPostalProvinceField = true;
    showPostalCountryField = true;
    showPostalCodeField = true;
    showClientVatNumberField = true;
    showIdNumberField = true;
    showMaritalStatusField = true;
    showRelativesFullNameField = true;
    showRelativesContactNumberField = true;
    showRelativesAddressField = true;
    showEmploymentStatusField = true;
    showEmployersNameField = true;
    showEmployersContactNumberField = true;
    showEmployersAddressField = true;
    // Form Labels
    nameLabel = RecipientSelectConstants.nameLabel;
    surnameLabel = RecipientSelectConstants.surnameLabel;
    homePhoneTelephoneLabel = RecipientSelectConstants.homeTelePhoneLabel;
    workTelephoneLabel = RecipientSelectConstants.workTelephoneLabel;
    cellphoneLabel = RecipientSelectConstants.cellphoneLabel;
    defaultCommunicationMethodLabel = RecipientSelectConstants.defaultCommunicationMethodLabel;
    emailRadioButtonLabel = RecipientSelectConstants.emailRadioButtonLabel;
    smsRadioButtonLabel = RecipientSelectConstants.smsRadioButtonLabel;
    emailLabel = RecipientSelectConstants.emailLabel;
    passportNumberLabel = RecipientSelectConstants.passportNumberLabel;
    genderLabel = RecipientSelectConstants.genderLabel;
    disabilityLabel = RecipientSelectConstants.disabilityLabel;
    organisationLabel = RecipientSelectConstants.organisationLabel;
    clientVatNumberLabel = RecipientSelectConstants.clientVatNumberLabel;
    designationLabel = RecipientSelectConstants.designationLabel;
    professionalBodyHeader = RecipientSelectConstants.professionalBodyHeader;
    professionalBodyLabel = RecipientSelectConstants.professionalBodyLabel;
    relativeDetailsBodyLabel = RecipientSelectConstants.relativeDetailsBodyLabel;
    employersDetailsHeader = RecipientSelectConstants.employerDetailsHeader;
    maritalStatusLabel = RecipientSelectConstants.maritalStatusLabel;
    idNumberLabel = RecipientSelectConstants.idNumberLabel;
    idPassportSelectionLabel = RecipientSelectConstants.idPassportSelectionLabel;
    relativesFullNameLabel = RecipientSelectConstants.relativesFullNameLabel;
    relativesContactNumberLabel = RecipientSelectConstants.relativesContactNumberLabel;
    relativesAddressLabel = RecipientSelectConstants.relativesAddressLabel;
    employmentStatusLabel = RecipientSelectConstants.employmentStatusLabel;
    employersNameLabel = RecipientSelectConstants.employersNameLabel;
    employersContactNumberLabel = RecipientSelectConstants.employersContactNumberLabel;
    employersAddressLabel = RecipientSelectConstants.employersAddressLabel;
    professionalBodyRegNoLabel = RecipientSelectConstants.professionalBodyRegNoLabel;
    streetAddressHeader = RecipientSelectConstants.streetAddressHeader;
    streetAddressLabel = RecipientSelectConstants.streetAddressLabel;
    wardAreaNameLabel = RecipientSelectConstants.wardAreaNameLabel;
    streetSuburbLabel = RecipientSelectConstants.streetSuburbLabel;
    streetCityLabel = RecipientSelectConstants.streetCityLabel;
    streetProvinceLabel = RecipientSelectConstants.streetProvinceLabel;
    streetCountryLabel = RecipientSelectConstants.streetCountryLabel;
    streetCodeLabel = RecipientSelectConstants.streetCodeLabel;
    postalDetailsHeader = RecipientSelectConstants.postalDetailsHeader;
    postalAddressLabel = RecipientSelectConstants.postalAddressLabel;
    postalSuburbLabel = RecipientSelectConstants.postalSuburbLabel;
    postalCityLabel = RecipientSelectConstants.postalCityLabel;
    postalProvinceLabel = RecipientSelectConstants.postalProvinceLabel;
    postalCountryLabel = RecipientSelectConstants.postalCountryLabel;
    postalCodeLabel = RecipientSelectConstants.postalCodeLabel;
    sameAsStreetAddressLabel = RecipientSelectConstants.sameAsStreetAddressLabel;
    groupsHeader = RecipientSelectConstants.groups;
    groupsLabel = RecipientSelectConstants.groupsLabel;
    componentName = RecipientSelectConstants.defaultComponentName;
    validationMessage = RecipientSelectConstants.validationMessage;
    SACAPRegistrationLabel = RecipientSelectConstants.sacapRegistrationHeader;
    sacapRegistrationNumberLabel = RecipientSelectConstants.sacapRegistrationLabel;
    sacapVerificationLabel = RecipientSelectConstants.sacapVerificationButtonLabel;
    // Form Controls
    idFormControlName = RecipientSelectConstants.idFormControlName;
    jobIdFormControlName = RecipientSelectConstants.jobIdFormControlName;
    moduleIdFormControlName = RecipientSelectConstants.moduleIdFormControlName;
    nameFormControlName = RecipientSelectConstants.nameFormControl;
    surnameFormControlName = RecipientSelectConstants.surnameFormControl;
    homePhoneFormControlName = RecipientSelectConstants.homeTelePhoneFormControl;
    workTelephoneFormControlName = RecipientSelectConstants.workTelephoneFormControl;
    cellphoneFormControlName = RecipientSelectConstants.cellphoneFormControlName;
    defaultCommunicationMethodFormControlName = RecipientSelectConstants.defaultCommunicationMethodFormControlName;
    emailFormControlName = RecipientSelectConstants.emailFormControlName;
    passportNumberFormControlName = RecipientSelectConstants.passportNumberFormControlName;
    genderFormControlName = RecipientSelectConstants.genderFormControlName;
    disabilityFormControlName = RecipientSelectConstants.disabilityFormControlName;
    organisationFormControlName = RecipientSelectConstants.organisationFormControlName;
    clientVatNumberFormControlName = RecipientSelectConstants.clientVatNumberFormControlName;
    designationFormControlName = RecipientSelectConstants.designationFormControlName;
    professionalBodyFormControlName = RecipientSelectConstants.professionalBodyFormControlName;
    professionalBodyRegNoFormControlName = RecipientSelectConstants.professionalBodyRegNoFormControlName;
    maritalStatusFormControlName = RecipientSelectConstants.maritalStatusFormControlName;
    idNumberFormControlName = RecipientSelectConstants.idNumberFormControlName;
    idPassportSelectionFormControlName = RecipientSelectConstants.idPassportSelectionFormControlName;
    idNumberSelection = RecipientSelectConstants.idNumberSelection;
    passportNumberSelection = RecipientSelectConstants.passportNumberSelection;
    relativesFullNameFormControlName = RecipientSelectConstants.relativesFullNameFormControlName;
    relativesContactNumberFormControlName = RecipientSelectConstants.relativesContactNumberFormControlName;
    relativesAddressFormControlName = RecipientSelectConstants.relativesAddressFormControlName;
    employmentStatusFormControlName = RecipientSelectConstants.employmentStatusFormControlName;
    employersNameFormControlName = RecipientSelectConstants.employersNameFormControlName;
    employersContactNumberFormControlName = RecipientSelectConstants.employersContactNumberFormControlName;
    employersAddressFormControlName = RecipientSelectConstants.employersAddressFormControlName;
    streetAddressFormControlName = RecipientSelectConstants.streetAddressFormControlName;
    wardAreaNameFormControlName = RecipientSelectConstants.wardAreaNameFormControlName;
    streetSuburbFormControlName = RecipientSelectConstants.streetSuburbFormControlName;
    streetCityFormControlName = RecipientSelectConstants.streetCityFormControlName;
    streetProvinceFormControlName = RecipientSelectConstants.streetProvinceFormControlName;
    streetCountryFormControlName = RecipientSelectConstants.streetCountryFormControlName;
    streetCodeFormControlName = RecipientSelectConstants.streetCodeFormControlName;
    postalAddressFormControlName = RecipientSelectConstants.postalAddressFormControlName;
    postalSuburbFormControlName = RecipientSelectConstants.postalSuburbFormControlName;
    postalCityFormControlName = RecipientSelectConstants.postalCityFormControlName;
    postalProvinceFormControlName = RecipientSelectConstants.postalProvinceFormControlName;
    postalCountryFormControlName = RecipientSelectConstants.postalCountryFormControlName;
    postalCodeFormControlName = RecipientSelectConstants.postalCodeFormControlName;
    groupsFormControlName = RecipientSelectConstants.groupsFormControlName;
    groupsStringArrayFormControlName = RecipientSelectConstants.groupsStringArrayFormControlName;
    sacapRegistrationNumberFormControlName = RecipientSelectConstants.sacapRegistrationNumberFormControl;
    sacapRegistrationVerifiedFormControlName = RecipientSelectConstants.sacapRegistrationNumberVerifiedFormControl;
    selectOptionTextOption = RecipientSelectConstants.PLEASE_SELECT_AN_OPTION;
    maximunLengthForThentyWord = 20;
    maximunLengthForFiftyWord = 50;
    maximunLengthForHundredWord = 100;
    maximunLengthForTwoFiftyWord = 250;
    maximunLengthFiveHundredWord = 500;
    showDefaultCommunicationMethods = true;
    requiredFieldsPlaceHolder = RecipientSelectConstants.requireFieldKey;
    getRecipientGroupSettingsSubscription;
    listenToClearRecipientSubscription;
    verifySACAPRegistrationSubscription;
    idPassportSelectionSubscription;
    constructor(recipientService, appCreateService, appControllerService, userInformationService, upperFirst, changeDetectorRef) {
        this.recipientService = recipientService;
        this.appCreateService = appCreateService;
        this.appControllerService = appControllerService;
        this.userInformationService = userInformationService;
        this.upperFirst = upperFirst;
        this.changeDetectorRef = changeDetectorRef;
        this.initialiseForm();
    }
    get value() {
        return this.recipientForm.value;
    }
    set value(recipient) {
        if (recipient) {
            // set recipient data from the parent component.
            this.recipientForm.get(this.idFormControlName)?.patchValue(recipient.id ? recipient.id : null);
            this.recipientForm.get(this.jobIdFormControlName)?.patchValue(recipient.jobId ? recipient.jobId : null);
            this.recipientForm.get(this.moduleIdFormControlName)?.patchValue(recipient.moduleId ? recipient.moduleId : null);
            this.recipientForm.get(this.nameFormControlName)?.patchValue(recipient.name ? recipient.name : null);
            this.recipientForm.get(this.surnameFormControlName)?.patchValue(recipient.surname ? recipient.surname : null);
            this.recipientForm.get(this.homePhoneFormControlName)?.patchValue(recipient.homePhone ? recipient.homePhone : null);
            this.recipientForm.get(this.workTelephoneFormControlName)?.patchValue(recipient.telephone ? recipient.telephone : null);
            this.recipientForm.get(this.cellphoneFormControlName)?.patchValue(recipient.cellphone ? recipient.cellphone : null);
            this.recipientForm.get(this.emailFormControlName)?.patchValue(recipient.email ? recipient.email : null);
            this.recipientForm.get(this.passportNumberFormControlName)?.patchValue(recipient.passportNumber ? recipient.passportNumber : null);
            this.recipientForm.get(this.genderFormControlName)?.patchValue(recipient.gender ? recipient.gender : null);
            this.recipientForm.get(this.disabilityFormControlName)?.patchValue(recipient.disability ? recipient.disability : null);
            this.recipientForm.get(this.defaultCommunicationMethodFormControlName)?.patchValue(recipient.defaultCommunicationMethod ? recipient.defaultCommunicationMethod : null);
            this.recipientForm.get(this.organisationFormControlName)?.patchValue(recipient.organisation ? recipient.organisation : null);
            this.recipientForm.get(this.clientVatNumberFormControlName)?.patchValue(recipient.clientVatNumber ? recipient.clientVatNumber : null);
            this.recipientForm.get(this.designationFormControlName)?.patchValue(recipient.designation ? recipient.designation : null);
            this.recipientForm.get(this.professionalBodyFormControlName)?.patchValue(recipient.professionalBody ? recipient.professionalBody : null);
            this.recipientForm.get(this.professionalBodyRegNoFormControlName)?.patchValue(recipient.professionalBodyRegNum ? recipient.professionalBodyRegNum : null);
            this.recipientForm.get(this.maritalStatusFormControlName)?.patchValue(recipient.maritalStatus ? recipient.maritalStatus : null);
            this.recipientForm.get(this.idNumberFormControlName)?.patchValue(recipient.idNumber ? recipient.idNumber : null);
            this.setIdPassportSelectionFromRecipient(recipient);
            this.recipientForm.get(this.relativesFullNameFormControlName)?.patchValue(recipient.relativesFullName ? recipient.relativesFullName : null);
            this.recipientForm.get(this.relativesContactNumberFormControlName)?.patchValue(recipient.relativesContactNumber ? recipient.relativesContactNumber : null);
            this.recipientForm.get(this.relativesAddressFormControlName)?.patchValue(recipient.relativesAddress ? recipient.relativesAddress : null);
            this.recipientForm.get(this.employmentStatusFormControlName)?.patchValue(recipient.employmentStatus ? recipient.employmentStatus : null);
            this.recipientForm.get(this.employersNameFormControlName)?.patchValue(recipient.employersName ? recipient.employersName : null);
            this.recipientForm.get(this.employersContactNumberFormControlName)?.patchValue(recipient.employersContactNumber ? recipient.employersContactNumber : null);
            this.recipientForm.get(this.employersAddressFormControlName)?.patchValue(recipient.employersAddress ? recipient.employersAddress : null);
            this.recipientForm.get(this.streetAddressFormControlName)?.patchValue(recipient.streetAddress ? recipient.streetAddress : null);
            this.recipientForm.get(this.wardAreaNameFormControlName)?.patchValue(recipient.wardAreaName ? recipient.wardAreaName : null);
            this.recipientForm.get(this.streetSuburbFormControlName)?.patchValue(recipient.streetSuburb ? recipient.streetSuburb : null);
            this.recipientForm.get(this.streetCityFormControlName)?.patchValue(recipient.streetCity ? recipient.streetCity : null);
            this.recipientForm.get(this.streetProvinceFormControlName)?.patchValue(recipient.streetProvince ? recipient.streetProvince : null);
            this.recipientForm.get(this.streetCountryFormControlName)?.patchValue(recipient.streetCountry ? recipient.streetCountry : null);
            this.recipientForm.get(this.streetCodeFormControlName)?.patchValue(recipient.streetCode ? recipient.streetCode : null);
            this.recipientForm.get(this.postalAddressFormControlName)?.patchValue(recipient.postalAddress ? recipient.postalAddress : null);
            this.recipientForm.get(this.postalSuburbFormControlName)?.patchValue(recipient.postalSuburb ? recipient.postalSuburb : null);
            this.recipientForm.get(this.postalCityFormControlName)?.patchValue(recipient.postalCity ? recipient.postalCity : null);
            this.recipientForm.get(this.postalProvinceFormControlName)?.patchValue(recipient.postalProvince ? recipient.postalProvince : null);
            this.recipientForm.get(this.postalCountryFormControlName)?.patchValue(recipient.postalCountry ? recipient.postalCountry : null);
            this.recipientForm.get(this.postalCodeFormControlName)?.patchValue(recipient.postalCode ? recipient.postalCode : null);
            if (recipient.hasOwnProperty(this.groupsStringArrayFormControlName) && recipient.groupsStringArray !== null && recipient.groupsStringArray.length > 0) {
                recipient.groups = this.setRecipientGroupsFromTheGroupsStringArray(recipient.groupsStringArray);
                this.recipientForm.get(this.groupsFormControlName).patchValue(recipient.groups);
            }
        }
        this.checkIfPostalDetailsIsTheSameAsResidentialDetails(recipient);
        this.onChange(recipient);
        this.onTouched();
    }
    ngOnChanges(changes) {
        if (changes && changes.hasOwnProperty("stepMetaRecipientGroups") && changes.stepMetaRecipientGroups.currentValue && changes.stepMetaRecipientGroups.currentValue.length > 0) {
            this.loadRecipientGroupSettings();
            this.configureComponentOnInit();
        }
    }
    onChange = () => {
    };
    onTouched = () => {
    };
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    setDisabledState(disabled) {
        if (disabled) {
            this.recipientForm.disable();
            this.disableEditing = true;
            this.recipientForm.get(this.postalProvinceFormControlName).disable();
            this.recipientForm.get(this.postalCountryFormControlName).disable();
        }
        else {
            this.recipientForm.enable();
            this.disableEditing = false;
            this.recipientForm.get(this.postalProvinceFormControlName).enable();
            this.recipientForm.get(this.postalCountryFormControlName).enable();
        }
    }
    writeValue(recipient) {
        if (recipient === null) {
            this.resetFormControls();
            return;
        }
        if (recipient) {
            this.value = recipient;
        }
    }
    // communicate the inner form validation-tab to the parent form
    validate(_) {
        return this.recipientForm.valid ? null : { formName: { valid: false } };
    }
    ngOnInit() {
        this.subscribeToFormChanges();
        this.configureComponentOnInit();
        this.subscribeToClearForm();
        this.checkOrganisationSettings();
        this.populateDropdowns();
        // this.populateVerifiedSACAPNumber();
    }
    ngOnDestroy() {
        if (this.onChangeSubscription !== undefined && this.onChangeSubscription !== null)
            this.onChangeSubscription.unsubscribe();
        if (this.getRecipientGroupSettingsSubscription !== undefined && this.getRecipientGroupSettingsSubscription !== null)
            this.getRecipientGroupSettingsSubscription.unsubscribe();
        if (this.listenToClearRecipientSubscription !== undefined && this.listenToClearRecipientSubscription !== null)
            this.listenToClearRecipientSubscription.unsubscribe();
        if (this.verifySACAPRegistrationSubscription !== undefined && this.verifySACAPRegistrationSubscription !== null)
            this.verifySACAPRegistrationSubscription.unsubscribe();
        if (this.idPassportSelectionSubscription !== undefined && this.idPassportSelectionSubscription !== null)
            this.idPassportSelectionSubscription.unsubscribe();
    }
    onResidentialInputEntered($event, formControlName) {
        if (this.sameAsResidentialChecked) {
            const inputValue = $event.target.value;
            const postalFormControl = this.recipientForm.get(formControlName);
            postalFormControl.patchValue(inputValue);
        }
    }
    onSameAsResidentialChecked($event) {
        const checkBoxStatus = $event.target.checked;
        if (checkBoxStatus) {
            this.sameAsResidentialChecked = true; // checks the checkbox and disables fields
            RecipientUtils.copyStreetDetailsDataToPostalDetailsFields(this.recipientForm, true);
            RecipientUtils.clearPostalDetailsValidators(this.recipientForm, true);
        }
        else {
            this.sameAsResidentialChecked = false;
            RecipientUtils.enablePostalDetails(this.recipientForm);
            RecipientUtils.restorePostalDetailsValidators(this.recipientForm, this.stepMetaRecipientGroups);
            this.recipientForm.updateValueAndValidity();
            this.changeDetectorRef.detectChanges();
        }
    }
    enablePostalSelects(postalProvinceFormControlName) {
        if (this.sameAsResidentialChecked) {
            this.recipientForm.get(postalProvinceFormControlName).enable();
        }
    }
    disablePostalSelects(postalProvinceFormControlName) {
        if (this.sameAsResidentialChecked) {
            this.recipientForm.get(postalProvinceFormControlName).disable();
        }
    }
    markControlAsTouched(controlName) {
        if (controlName) {
            this.recipientForm.get(controlName).markAllAsTouched();
            this.recipientForm.get(controlName).updateValueAndValidity();
        }
    }
    loadRecipient(recipient) {
        if (recipient) {
            if (!this.disableEditing && this.showAllFormFields) {
                // enable postal formControls when loading recipient from the filter
                this.sameAsResidentialChecked = false; // reset sameAsResidential checkbox
                RecipientUtils.enablePostalDetails(this.recipientForm);
                RecipientUtils.restorePostalDetailsValidators(this.recipientForm, this.stepMetaRecipientGroups);
            }
            this.value = recipient;
        }
    }
    updateModel() {
        if (this.stepMetaRecipientGroups.length > 0) {
            const currentGroupStringArray = this.recipientForm.get(this.groupsStringArrayFormControlName).value;
            const groups = currentGroupStringArray.map((groupStringValue) => {
                return {
                    groupName: groupStringValue, groupType: this.stepMetaRecipientGroups[0].groupType
                };
            });
            this.recipientForm.get(this.groupsFormControlName).patchValue(groups);
        }
    }
    onRadioButtonChanged(selectedMethodOfCommunication) {
        const preferredMethodOfCommunication = selectedMethodOfCommunication.trim().toLowerCase();
        const emailFormControl = this.recipientForm.get(this.emailFormControlName);
        const cellphoneFormControl = this.recipientForm.get(this.cellphoneFormControlName);
        const recipientGroup = this.stepMetaRecipientGroups[0];
        const isCellPhoneRequiredFromMetaData = this.isCellphoneFormFieldRequiredInTheMetadata(recipientGroup);
        const isEmailRequiredFromMetadata = this.isEmailFormFieldRequiredInTheMetadata(recipientGroup);
        if (preferredMethodOfCommunication.toLowerCase().trim() === "email") {
            this.setEmailFormFieldAsRequired(emailFormControl);
            if (isCellPhoneRequiredFromMetaData) {
                this.setCellphoneFormFieldAsRequired(cellphoneFormControl);
            }
            else {
                this.clearCellphoneFormFieldRequiredValidation(cellphoneFormControl);
            }
        }
        if (preferredMethodOfCommunication.toLowerCase().trim() === "sms") {
            this.setCellphoneFormFieldAsRequired(cellphoneFormControl);
            // if (isEmailRequiredFromMetadata) {
            //   this.setEmailFormFieldAsRequired(emailFormControl);
            // } else {
            //   this.clearEmailFormFieldRequiredValidation(emailFormControl);
            // }
        }
    }
    onVerifySacapDetails() {
        const constituentId = this.recipientForm.get(this.sacapRegistrationNumberFormControlName).value;
        this.verifySACAPRegistrationSubscription = this.recipientService.verifySACAPRegistration(constituentId).subscribe({
            next: (response) => {
                if (response && response.professionalNumber) {
                    this.setVerifiedSACAPNumber(response.professionalNumber);
                    this.recipientForm.get(this.sacapRegistrationNumberFormControlName).patchValue(response.professionalNumber);
                }
                this.setSACAPRecipientData(response);
                this.setSACAPRecipientVerification();
                this.appControllerService.showMessage("membership validated", AlertType.Success);
            }, error: (error) => {
                this.clearSACAPRecipientVerification();
                switch (error.status) {
                    case 404: {
                        this.appControllerService.showMessage(error.error, AlertType.Error);
                        break;
                    }
                    case 403: {
                        this.appControllerService.showMessage(error.error, AlertType.Error);
                        break;
                    }
                    default: {
                        this.appControllerService.handleServerErrorMessage("Recipient verification", error, CRUDOperation.Get);
                    }
                }
            }
        });
    }
    ngAfterViewInit() {
        if (this.showSACAPOptions) {
            this.checkSACAPOptions();
            this.populateVerifiedSACAPNumber();
            this.changeDetectorRef.detectChanges();
        }
    }
    markFormControlsAsTouched() {
        this.recipientForm.markAllAsTouched();
        if (this.showSACAPOptions) {
            if (!this.recipientForm.get(this.sacapRegistrationNumberFormControlName).hasValidator(Validators.required)) {
                this.recipientForm.get(this.sacapRegistrationNumberFormControlName).addValidators([Validators.required, Validators.minLength(0)]);
            }
            this.recipientForm.updateValueAndValidity();
            this.recipientForm.get(this.sacapRegistrationNumberFormControlName).markAsTouched();
        }
        this.recipientForm.updateValueAndValidity();
    }
    loadRecipientGroupSettings() {
        if (this.recipientGroupSettings.length === 0) {
            this.recipientService.getRecipientGroupSettings(+this.appControllerService.selectedModuleID, false).pipe(take(1)).subscribe({
                next: (response) => {
                    this.recipientGroupSettings = response;
                    this.setRequiredFields();
                }, error: (error) => {
                    this.appControllerService.showMessage("Configuration for recipient group settings incomplete", AlertType.Error);
                }
            });
        }
    }
    checkSACAPOptions() {
        if (this.showSACAPOptions) {
            // add sacap controls
            this.recipientForm.addControl(this.sacapRegistrationNumberFormControlName, new FormControl(null, [Validators.required, Validators.minLength(0)]));
            this.recipientForm.addControl(this.sacapRegistrationVerifiedFormControlName, new FormControl(null, Validators.required));
            this.recipientForm.updateValueAndValidity();
        }
    }
    getOrganisationSettings() {
        const organisationId = Number(this.appControllerService.selectedOrganisationId);
        const organisationInformation = this.userInformationService.getOrganisationInformation(organisationId);
        if (organisationInformation?.settings) {
            return organisationInformation.settings;
        }
        else {
            return null;
        }
    }
    setRecipientGroupsFromTheGroupsStringArray(groupsStringArray) {
        // builds group object from the metadata and the groupStringArray
        const recipientGroups = [];
        groupsStringArray.forEach((groupNameFromStringArray) => {
            for (const groupFromMetadata of this.stepMetaRecipientGroups) {
                if (groupFromMetadata.groupName.toLowerCase().trim() === groupNameFromStringArray.toLowerCase().trim()) {
                    recipientGroups.push({ groupName: groupNameFromStringArray, groupType: groupFromMetadata.groupType });
                }
            }
        });
        return recipientGroups;
    }
    initialiseForm() {
        // initialise formControls
        this.recipientForm = new FormGroup({
            id: new FormControl(),
            sacapRegistrationNumber: new FormControl(0),
            jobId: new FormControl(this.jobId ? +this.jobId : null),
            moduleId: new FormControl(this.appControllerService.selectedModuleID ? Number(this.appControllerService.selectedModuleID) : null),
            name: new FormControl(),
            surname: new FormControl(),
            homePhone: new FormControl(null, phoneNumberValidator),
            telephone: new FormControl(null, phoneNumberValidator),
            cellphone: new FormControl(null, phoneNumberValidator),
            defaultCommunicationMethod: new FormControl(this.emailRadioButtonLabel),
            email: new FormControl(null, Validators.email),
            passportNumber: new FormControl(),
            gender: new FormControl(),
            disability: new FormControl(),
            organisation: new FormControl(),
            clientVatNumber: new FormControl(),
            designation: new FormControl(),
            professionalBody: new FormControl(),
            professionalBodyRegNum: new FormControl(),
            maritalStatus: new FormControl(),
            relativesFullName: new FormControl(),
            relativesContactNumber: new FormControl(),
            relativesAddress: new FormControl(),
            employmentStatus: new FormControl(),
            employersName: new FormControl(),
            employersContactNumber: new FormControl(null, phoneNumberValidator),
            employersAddress: new FormControl(),
            idNumber: new FormControl(),
            idPassportSelection: new FormControl(),
            streetAddress: new FormControl(),
            wardAreaName: new FormControl(),
            streetSuburb: new FormControl(),
            streetCity: new FormControl(),
            streetProvince: new FormControl(),
            streetCountry: new FormControl(SharedConstants.DEFAULT_COUNTRY),
            streetCode: new FormControl(),
            postalAddress: new FormControl(),
            postalSuburb: new FormControl(),
            postalCity: new FormControl(),
            postalProvince: new FormControl(),
            postalCountry: new FormControl(SharedConstants.DEFAULT_COUNTRY),
            postalCode: new FormControl(),
            groupsStringArray: new FormControl([]),
            groups: new FormControl(null)
        });
    }
    subscribeToFormChanges() {
        // any time the inner form changes update the parent of any change
        this.onChangeSubscription = this.recipientForm.valueChanges.subscribe(recipient => {
            this.onChange(recipient);
            this.onTouched();
        });
        this.idPassportSelectionSubscription = this.recipientForm.get(this.idPassportSelectionFormControlName).valueChanges.subscribe(() => {
            this.updateIdPassportSelectionState();
        });
    }
    populateGroupsDropdown() {
        // Populates the groups dropdown
        if (this.isGroupsComingFromMetadata) {
            if (this.stepMetaRecipientGroups.length === 0) {
                this.stepMetaPropertyNotSetErrMessage("stepMetaRecipientGroups");
                return;
            }
            this.stepMetaRecipientGroups = RecipientUtils.standardizeRecipientGroupsObject(this.stepMetaRecipientGroups);
            this.groupsOptions = this.stepMetaRecipientGroups.map((group => {
                return group.groupName;
            }));
        }
        else {
            // if groups are not coming from the metadata fetch them from the lookups
            this.getRecipientGroupsSettings();
        }
    }
    getRecipientGroupsSettings() {
        // Fetch groups from the recipientGroups lookup
        this.getRecipientGroupSettingsSubscription = this.recipientService.getRecipientGroupSettings(this.appControllerService.selectedModuleID ? Number(this.appControllerService.selectedModuleID) : null, true).subscribe({
            next: (groupSettings) => {
                if (groupSettings && groupSettings.length > 0) {
                    this.populateRecipientGroups(groupSettings);
                }
            }, error: (error) => {
                this.appControllerService.handleServerErrorMessage(this.componentName, error, CRUDOperation.Get);
            }
        });
    }
    populateRecipientGroups(groupSettings) {
        // populates the dropdown with groups from the lookups
        groupSettings.forEach(groupLookup => {
            const lookup = groupLookup;
            this.groupsOptions.push(lookup.name);
        });
        this.groupsOptions.sort((a, b) => a?.localeCompare(b));
        this.changeDetectorRef.markForCheck();
    }
    stepMetaPropertyNotSetErrMessage(propertyName) {
        // throws warning when one of the properties of the metadata is not set
        // this.appControllerService.showMessage(`The ${propertyName} ${this.metadataPropertyNotSetErrMsg}`, AlertType.Warning);
    }
    checkIfPostalDetailsIsTheSameAsResidentialDetails(recipient) {
        const postalDetailsMatchResidentialDetails = RecipientUtils.checkAddressDetails(recipient, this.recipientForm);
        if (postalDetailsMatchResidentialDetails) {
            RecipientUtils.disablePostalDetails(this.recipientForm);
            this.sameAsResidentialChecked = true;
            this.changeDetectorRef.detectChanges();
        }
    }
    configureComponentOnInit() {
        // configures the component when it is initialized
        this.populateGroupsDropdown();
        this.setGroupsFromMetadata();
        this.setDisableEditing();
        this.setConfigurableLabel();
        this.setJobId();
        this.showOrHideGroupsDropdown();
        this.changeDetectorRef.detectChanges();
    }
    setRequiredFields() {
        if (this.stepMetaRecipientGroups.length > 0) {
            const group = this.stepMetaRecipientGroups[0];
            if (this.recipientGroupSettings.length > 0) {
                const settings = this.recipientGroupSettings.find(x => x.name.trim() === group.groupName.trim() && x.type === group.groupType);
                if (settings) {
                    group.requiredFields = JSON.parse(settings.configuration);
                    this.loadRequiredFields(group);
                }
                else {
                    this.appControllerService.showMessage(`Configuration for recipient group settings incomplete GroupName: ${group.groupName}`, AlertType.Error);
                }
            }
            else {
                this.appControllerService.showMessage("Configuration for recipient group settings incomplete", AlertType.Error);
            }
        }
    }
    setGroupsFromMetadata() {
        // sets the recipient groups from the metadata and hides the group dropdown if only 1 group is available from metadata
        if (this.stepMetaRecipientGroups.length === 1) {
            const groups = this.stepMetaRecipientGroups.map(((group) => {
                return {
                    groupName: group.groupName, groupType: group.groupType
                };
            }));
            if (this.isGroupsComingFromMetadata && this.recipientForm) {
                this.recipientForm.get(this.groupsStringArrayFormControlName).setValue([groups[0].groupName]);
                this.recipientForm.get(this.groupsFormControlName).setValue([groups[0]]);
                this.showRecipientGroupsDropdown = false;
            }
        }
    }
    showOrHideGroupsDropdown() {
        // shows or hides the recipient groups dropdown
        if (this.showGroupsDropdown) {
            this.showRecipientGroupsDropdown = true;
        }
        else {
            this.showRecipientGroupsDropdown = false;
        }
    }
    setDisableEditing() {
        if (this.disableEditing) {
            this.setDisabledState(this.disableEditing);
        }
    }
    setConfigurableLabel() {
        this.recipientFormLabelHeading = this.configurableLabel ? `${this.configurableLabel} details` : `Personal details`;
        this.recipientFormLabelHeading = this.upperFirst.transform(this.recipientFormLabelHeading.toLowerCase());
        if (this.recipientFormLabelHeading === null || this.recipientFormLabelHeading === undefined) {
            this.stepMetaPropertyNotSetErrMessage("label");
        }
    }
    subscribeToClearForm() {
        this.listenToClearRecipientSubscription = this.recipientService.listenToClearRecipient().subscribe(isCleaned => {
            if (!isCleaned)
                return;
            this.value = null;
            this.recipientForm.reset();
        });
    }
    resetFormControls() {
        this.sameAsResidentialChecked = false;
        RecipientUtils.enablePostalDetails(this.recipientForm);
        this.recipientForm.reset();
        if (this.showDefaultCommunicationMethods) {
            this.recipientForm.get(this.defaultCommunicationMethodFormControlName).setValue(this.emailRadioButtonLabel);
        }
        this.recipientForm.get(this.streetCountryFormControlName)?.patchValue(SharedConstants.DEFAULT_COUNTRY);
        this.recipientForm.get(this.postalCountryFormControlName)?.patchValue(SharedConstants.DEFAULT_COUNTRY);
        this.recipientForm.get(this.moduleIdFormControlName).patchValue(this.appControllerService.selectedModuleID ? Number(this.appControllerService.selectedModuleID) : null);
        this.configureComponentOnInit();
        this.checkSACAPOptions();
    }
    setJobId() {
        if (this.jobId && +this.jobId >= 0) {
            this.recipientForm.get(this.jobIdFormControlName).patchValue(+this.jobId);
        }
    }
    loadRequiredFields(data) {
        data.requiredFields.forEach((item) => {
            item.name = this.formatObjectKey(item.name);
            const control = this.recipientForm.get(item.name);
            if (control) {
                if (item.required) {
                    control.addValidators([Validators.required]);
                    if (item.name === this.homePhoneFormControlName) {
                        control.addValidators([phoneNumberValidator]);
                    }
                    if (item.name === this.workTelephoneFormControlName) {
                        control.addValidators([phoneNumberValidator]);
                    }
                    if (item.name === this.cellphoneFormControlName) {
                        control.addValidators([phoneNumberValidator]);
                    }
                    if (item.name === this.streetCodeFormControlName) {
                        control.addValidators([Validators.minLength(4)]);
                    }
                    if (item.name === this.postalCodeFormControlName) {
                        control.addValidators([Validators.minLength(4)]);
                    }
                    if (item.name === this.emailFormControlName) {
                        control.addValidators([Validators.email]);
                    }
                    this.checkSACAPOptions();
                    control.updateValueAndValidity();
                }
            }
            if (item.name === this.idNumberFormControlName) {
                this.idNumberConfiguredRequired = item.required;
            }
            if (item.name === this.passportNumberFormControlName) {
                this.passportNumberConfiguredRequired = item.required;
            }
            this.showOrHideControl(item.name, item.visible);
        });
        this.recipientForm.updateValueAndValidity();
        this.changeDetectorRef.markForCheck();
    }
    formatObjectKey(name) {
        const wordArr = name.split(" ");
        wordArr.forEach((word, index) => {
            wordArr[index] = word.charAt(0).toUpperCase() + word.slice(1);
        });
        name = wordArr.join("");
        let keyToChange = name;
        if (keyToChange.toLocaleLowerCase() === "professionalbodyregistrationnumber") {
            keyToChange = "professionalBodyRegNum";
        }
        if (keyToChange.toLocaleLowerCase() === "ward/areaname") {
            keyToChange = "wardAreaName";
        }
        if (keyToChange === "Homephone") {
            keyToChange = "HomePhone";
        }
        const formattedString = keyToChange.charAt(0).toLowerCase() + keyToChange.slice(1);
        return formattedString;
    }
    isCellphoneFormFieldRequiredInTheMetadata(recipientGroup) {
        let isCellphoneRequired = false;
        if (this.stepMetaRecipientGroups.length > 0 && recipientGroup.hasOwnProperty(this.requiredFieldsPlaceHolder) && this.getPropertyThatMatchesDataCase(recipientGroup.requiredFields, "Cellphone", "cellphone")) {
            isCellphoneRequired = true;
        }
        return isCellphoneRequired;
    }
    isEmailFormFieldRequiredInTheMetadata(recipientGroup) {
        let isEsmailRequired = false;
        if (this.stepMetaRecipientGroups.length > 0 && recipientGroup.hasOwnProperty(this.requiredFieldsPlaceHolder) && this.getPropertyThatMatchesDataCase(recipientGroup.requiredFields, "Email", "email")) {
            isEsmailRequired = true;
        }
        return isEsmailRequired;
    }
    setEmailFormFieldAsRequired(emailFormControl) {
        emailFormControl.setValidators([Validators.required, Validators.email]);
        emailFormControl.updateValueAndValidity();
    }
    setCellphoneFormFieldAsRequired(cellphoneFormControl) {
        cellphoneFormControl.setValidators([Validators.required, phoneNumberValidator]);
        cellphoneFormControl.updateValueAndValidity();
    }
    clearCellphoneFormFieldRequiredValidation(cellphoneFormControl) {
        cellphoneFormControl.clearValidators();
        cellphoneFormControl.addValidators(phoneNumberValidator);
    }
    clearEmailFormFieldRequiredValidation(emailFormControl) {
        emailFormControl.clearValidators();
        emailFormControl.addValidators(Validators.email);
    }
    setIdPassportSelectionFromRecipient(recipient) {
        if (recipient.idNumber) {
            this.recipientForm.get(this.idPassportSelectionFormControlName).patchValue(this.idNumberSelection, { emitEvent: false });
        }
        else if (recipient.passportNumber) {
            this.recipientForm.get(this.idPassportSelectionFormControlName).patchValue(this.passportNumberSelection, { emitEvent: false });
        }
        else {
            this.recipientForm.get(this.idPassportSelectionFormControlName).patchValue(null, { emitEvent: false });
        }
        this.updateIdPassportSelectionState();
    }
    updateIdPassportSelectionState() {
        const selectionControl = this.recipientForm.get(this.idPassportSelectionFormControlName);
        const selectedIdentificationType = selectionControl.value;
        if (this.idNumberConfiguredVisible && this.passportNumberConfiguredVisible) {
            this.showIdPassportSelectionField = true;
            selectionControl.setValidators(Validators.required);
            selectionControl.updateValueAndValidity({ emitEvent: false });
            if (selectedIdentificationType === this.idNumberSelection) {
                this.showIdNumberField = true;
                this.showPassportNumberField = false;
                this.setIdPassportFieldValidator(this.idNumberFormControlName, this.idNumberConfiguredRequired);
                this.recipientForm.get(this.passportNumberFormControlName).reset(null, { emitEvent: false });
                this.setIdPassportFieldValidator(this.passportNumberFormControlName, false);
            }
            else if (selectedIdentificationType === this.passportNumberSelection) {
                this.showIdNumberField = false;
                this.showPassportNumberField = true;
                this.recipientForm.get(this.idNumberFormControlName).reset(null, { emitEvent: false });
                this.setIdPassportFieldValidator(this.idNumberFormControlName, false);
                this.setIdPassportFieldValidator(this.passportNumberFormControlName, this.passportNumberConfiguredRequired);
            }
            else {
                this.showIdNumberField = false;
                this.showPassportNumberField = false;
                this.setIdPassportFieldValidator(this.idNumberFormControlName, false);
                this.setIdPassportFieldValidator(this.passportNumberFormControlName, false);
            }
        }
        else {
            this.showIdPassportSelectionField = false;
            selectionControl.clearValidators();
            selectionControl.updateValueAndValidity({ emitEvent: false });
            this.showIdNumberField = this.idNumberConfiguredVisible;
            this.showPassportNumberField = this.passportNumberConfiguredVisible;
            this.setIdPassportFieldValidator(this.idNumberFormControlName, this.idNumberConfiguredRequired);
            this.setIdPassportFieldValidator(this.passportNumberFormControlName, this.passportNumberConfiguredRequired);
        }
    }
    setIdPassportFieldValidator(controlName, required) {
        const control = this.recipientForm.get(controlName);
        if (required) {
            control.setValidators(Validators.required);
        }
        else {
            control.clearValidators();
        }
        control.updateValueAndValidity({ emitEvent: false });
    }
    getPropertyThatMatchesDataCase(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    setDefaultCommunicationSettings(organisationSettings) {
        this.showDefaultCommunicationMethods = false;
        const isSMSEnabledFromOrganisationSettings = organisationSettings.enableSms;
        const hasSMSProvider = (!(organisationSettings.smsProvider === "" || organisationSettings.smsProvider === "null" || organisationSettings.smsProvider === null));
        if (isSMSEnabledFromOrganisationSettings && hasSMSProvider) {
            this.showDefaultCommunicationMethods = true;
        }
        else {
            this.disableCommunicationMethods();
        }
        this.changeDetectorRef.detectChanges();
    }
    checkOrganisationSettings() {
        const organisationSettings = this.getOrganisationSettings();
        if (organisationSettings) {
            this.setDefaultCommunicationSettings(organisationSettings);
        }
        else {
            this.disableCommunicationMethods();
        }
    }
    disableCommunicationMethods() {
        this.showDefaultCommunicationMethods = false;
    }
    setSACAPRecipientData(memberData) {
        this.recipientForm.get(this.nameFormControlName).patchValue(memberData.firstname);
        this.recipientForm.get(this.nameFormControlName).disable();
        this.recipientForm.get(this.surnameFormControlName).patchValue(memberData.lastname);
        this.recipientForm.get(this.surnameFormControlName).disable();
        this.recipientForm.get(this.professionalBodyFormControlName).patchValue("SACAP");
        this.recipientForm.get(this.professionalBodyFormControlName).disable();
        this.recipientForm.get(this.professionalBodyRegNoFormControlName).patchValue(memberData.professionalNumber);
        this.recipientForm.get(this.professionalBodyRegNoFormControlName).disable();
        this.recipientForm.get(this.emailFormControlName).patchValue(memberData.email);
        this.recipientForm.get(this.emailFormControlName).disable();
        this.recipientForm.get(this.cellphoneFormControlName).patchValue(memberData.telephone);
        this.recipientForm.get(this.cellphoneFormControlName).disable();
    }
    setSACAPRecipientVerification() {
        const control = this.recipientForm.get(this.sacapRegistrationVerifiedFormControlName);
        if (control) {
            control.setValue(true);
        }
    }
    clearSACAPRecipientVerification() {
        const control = this.recipientForm.get(this.sacapRegistrationVerifiedFormControlName);
        if (control) {
            control.reset();
        }
    }
    // Method to set the verified SACAP number
    setVerifiedSACAPNumber(sacapNumber) {
        this.verifiedSACAPNumber = sacapNumber;
    }
    populateVerifiedSACAPNumber() {
        if (this.verifiedSACAPNumber) {
            const sacapControl = this.recipientForm.get(this.sacapRegistrationNumberFormControlName);
            if (sacapControl) {
                sacapControl.patchValue(this.verifiedSACAPNumber);
                sacapControl.markAsTouched();
            }
        }
    }
    showOrHideControl(controlName, visible) {
        switch (controlName) {
            case this.nameFormControlName:
                this.showNameField = visible;
                break;
            case this.surnameFormControlName:
                this.showSurnameField = visible;
                break;
            case this.homePhoneFormControlName:
                this.showHomeTelephoneField = visible;
                break;
            case this.workTelephoneFormControlName:
                this.showWorkTelephoneField = visible;
                break;
            case this.cellphoneFormControlName:
                this.showCellphoneField = visible;
                break;
            case this.emailFormControlName:
                this.showEmailField = visible;
                break;
            case this.passportNumberFormControlName:
                this.passportNumberConfiguredVisible = visible;
                this.showPassportNumberField = visible;
                this.updateIdPassportSelectionState();
                break;
            case this.genderFormControlName:
                this.showGenderField = visible;
                break;
            case this.disabilityFormControlName:
                this.showDisabilityField = visible;
                break;
            case this.idNumberFormControlName:
                this.idNumberConfiguredVisible = visible;
                this.showIdNumberField = visible;
                this.updateIdPassportSelectionState();
                break;
            case this.organisationFormControlName:
                this.showOrganisationField = visible;
                break;
            case this.designationFormControlName:
                this.showDesignationField = visible;
                break;
            case this.professionalBodyFormControlName:
                this.showProfessionalBodyField = visible;
                break;
            case this.professionalBodyRegNoFormControlName:
                this.showProfessionalBodyRegNumField = visible;
                break;
            case this.maritalStatusFormControlName:
                this.showMaritalStatusField = visible;
                break;
            case this.relativesFullNameFormControlName:
                this.showRelativesFullNameField = visible;
                break;
            case this.clientVatNumberFormControlName:
                this.showClientVatNumberField = visible;
                break;
            case this.relativesContactNumberFormControlName:
                this.showRelativesContactNumberField = visible;
                break;
            case this.relativesAddressFormControlName:
                this.showRelativesAddressField = visible;
                break;
            case this.employmentStatusFormControlName:
                this.showEmploymentStatusField = visible;
                break;
            case this.employersNameFormControlName:
                this.showEmployersNameField = visible;
                break;
            case this.employersContactNumberFormControlName:
                this.showEmployersContactNumberField = visible;
                break;
            case this.employersAddressFormControlName:
                this.showEmployersAddressField = visible;
                break;
            case this.streetAddressFormControlName:
                this.showStreetAddressField = visible;
                break;
            case this.wardAreaNameFormControlName:
                this.showWardAreaNameField = visible;
                break;
            case this.streetCityFormControlName:
                this.showStreetCityField = visible;
                break;
            case this.streetSuburbFormControlName:
                this.showStreetSuburbField = visible;
                break;
            case this.streetProvinceFormControlName:
                this.showStreetProvinceField = visible;
                break;
            case this.streetCountryFormControlName:
                this.showStreetCountryField = visible;
                break;
            case this.streetCodeFormControlName:
                this.showStreetCodeField = visible;
                break;
            case this.postalAddressFormControlName:
                this.showPostalAddressField = visible;
                break;
            case this.postalCityFormControlName:
                this.showPostalCityField = visible;
                break;
            case this.postalSuburbFormControlName:
                this.showPostalSuburbField = visible;
                break;
            case this.postalProvinceFormControlName:
                this.showPostalProvinceField = visible;
                break;
            case this.postalCountryFormControlName:
                this.showPostalCountryField = visible;
                break;
            case this.postalCodeFormControlName:
                this.showPostalCodeField = visible;
                break;
            default:
                break;
        }
    }
    populateDropdowns() {
        const gender$ = this.getLookups('Recipient gender', 'Recipient disabled');
        gender$.subscribe({
            next: (options) => {
                this.genderOptions = options.filter(opt => opt.name === 'Recipient gender');
                this.disabilityOptions = options.filter(opt => opt.name === 'Recipient disabled');
                this.changeDetectorRef.detectChanges();
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage(RecipientSelectConstants.MISSING_LOOKUPS, error, CRUDOperation.Get);
            }
        });
    }
    getLookups(name, name2) {
        const params = {
            $filter: `moduleId eq ${Number(this.appControllerService.selectedModuleID)} and deleted eq false and (name eq '${name}' or name eq '${name2}')`,
        };
        return this.appCreateService.getLookupsObservables(params).pipe(map(response => (response.value || []).map(item => ({
            ...item,
            content: JSON.parse(item.content)
        }))));
    }
    markAllAsTouched() {
        this.recipientForm.markAllAsTouched();
        if (this.showSACAPOptions) {
            this.recipientForm.get(this.sacapRegistrationNumberFormControlName).markAsTouched();
        }
        this.recipientForm.updateValueAndValidity();
    }
    static ctorParameters = () => [
        { type: RecipientService },
        { type: ApplicationCreateService },
        { type: AppControllerService },
        { type: UserInformationService },
        { type: UcFirstPipe },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        overrideGroup: [{ type: Input }],
        stepMetaRecipientGroups: [{ type: Input }],
        isGroupsComingFromMetadata: [{ type: Input }],
        showGroupsDropdown: [{ type: Input }],
        disableEditing: [{ type: Input }],
        showAllFormFields: [{ type: Input }],
        disableFilter: [{ type: Input }],
        jobId: [{ type: Input }],
        formName: [{ type: Input }],
        configurableLabel: [{ type: Input }],
        showSACAPOptions: [{ type: Input }]
    };
};
RecipientSelectComponent = __decorate([
    Component({
        selector: "app-recipient-select",
        template: __NG_CLI_RESOURCE__0,
        providers: [{
                provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RecipientSelectComponent), multi: true
            }, {
                provide: NG_VALIDATORS, useExisting: forwardRef(() => RecipientSelectComponent), multi: true
            }],
        styles: [__NG_CLI_RESOURCE__1]
    })
], RecipientSelectComponent);
export { RecipientSelectComponent };
